import React from 'react';
import PropTypes from 'prop-types';
import styles from "./ResetPassword.module.scss";
import GenericFormContainer from '../../../helpers/GenericFormContainer';
import { Validations } from '../../../helpers/validations';

import { UserService } from '../../../services/UserService';

import AuthGeneric from '../../../components/Auth/layouts/AuthGeneric'
import RoundedButton from '../../../components/Auth/atoms/buttons/RoundedButton'
import PasswordInput from '../../../components/Auth/atoms/forms/InputPasswordAuth'

import Logo from '../../../components/Auth/atoms/images/Logo'
import i18n from 'i18n';

export class ResetPasswordView extends GenericFormContainer {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            userData: {
                password: null
            },
            buttonState: 'disabled',
            passwordValidation: [false, false, false],
            passwordError: false
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.beforeSubmit();
        UserService.resetConfirm(this.state.userData.password, this.props.match.params.key
        ).then(data => {
            this.afterSubmit();
            this.props.history.push('/login');
        }).catch((error) => {
            this.afterSubmit();
            this.dealWithError(error, i18n.t("unable.to.reset.password"));
        }
        );
    };

    handleChange = (e) => {
        let id = e.target.id
        let userData = { ...this.state.userData };
        userData[id] = e.target.value;
        this.setState({
            userData: userData
        }, _ => {
            this.validateFieldsAfterChange(userData);
        })
    }

    validateFieldsAfterChange = (userData) => {
        let passwordValidation = Validations.password(userData.password)
        let passwordError = passwordValidation.every((v) => v === true) ? null : i18n.t("invalid.password")
        //errors.password = passwordError
        this.setState({
            passwordValidation: passwordValidation,
            passwordError: passwordError,
            //errors: errors
        }, _ => {
            this.updateButtonState(userData);
        })
    }

    updateButtonState = (userData) => {
        if (userData.password && !this.state.passwordError) {
            this.setState({
                buttonState: 'enabled'
            })
        } else {
            this.setState({
                buttonState: 'disabled'
            })
        }
    }


    handleGoBack = () => {
        return true
    }

    render() {
        const content = <div className={styles['reset-password']}>
            <form onSubmit={this.handleSubmit}>
                <Logo></Logo>
                <p className={styles['title']}>{i18n.t("reset.password")}</p>
                <p className={styles['subtitle']}>{i18n.t("reset.password.sub")}</p>
                <p className={styles['second-subtitle']}>{i18n.t("reset.password.sub2")}</p>
                <div className={styles['form-container']}>
                    <div className={styles["inputs-wrapper"]}>
                        <PasswordInput validate={true} validationResults={this.state.passwordValidation} handleChange={this.handleChange} id={'password'} error={this.state.errors['password'] ?? this.state.message}></PasswordInput>
                    </div>
                </div>
                <div className={styles["rounded-button-wrapper"]}>
                    <RoundedButton legend={i18n.t("create.password")} handleClick={this.handleSubmit} state={this.state.buttonState}></RoundedButton>
                </div>
            </form>
        </div>

        return (
            <div className={styles['reset-password-container']}>
                <AuthGeneric title={i18n.t("reset.password")} version={'header'} content={content}></AuthGeneric>
            </div>
        )
    }

}


ResetPasswordView.propTypes = {
    handleChange: PropTypes.func,
    label: PropTypes.string
};

export default ResetPasswordView;